export const implement = `<div id="calendar"></div>

<script src="https://moment.github.io/luxon/global/luxon.min.js"></script>
<script src="js/calendar.js"></script>
<script>
const options = {
    CalendarCSSClass: 'bg-dark rounded-lg shadow-sm',
    JumpToDateFields: {
        yearsBackward: 20,
        yearsForward: 20,
        fieldPosition: 'after-title' // 'before-title', 'bottom'
    },
    SelectedDates: [{
        day: luxon.DateTime.local().plus({ days: -1 }).day,
        month: luxon.DateTime.local().month,
        year: luxon.DateTime.local().year
    }, {
        day: luxon.DateTime.local().day,
        month: luxon.DateTime.local().month,
        year: luxon.DateTime.local().year
    }, {
        day: luxon.DateTime.local().plus({ days: 2 }).day,
        month: luxon.DateTime.local().month,
        year: luxon.DateTime.local().year
    }]
}


const calendar = new Calendar('#calendar', options);

function captureCalendarDate(date) {
    console.log(date)
}
</script>`